import React from "react";
import { Button } from "../../components/Buttons";
import { Input } from "../../components/Input";
import { Modal } from "../../components/Modal";
import { HexpertModalProps } from "../../types/hexpertTypes";
import { imageUrlHelper } from "../../helpers/imageHelper";
import './HexpertModalBlock.scss';

type HexpertModalBlockProps = {
  isConfirm?: boolean;
  action?: () => void;
  onInputChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  inputValue?: string;
  invalidEmail?: boolean;
} & HexpertModalProps;

export const HexpertModalBlock = ({
  ModalButtonText,
  ModalConfirmationDescription,
  ModalConfirmationHeading,
  ModalDescription,
  ModalHeading,
  ModalImage,
  ModalQuoteText,
  ModalTextboxPlaceholder,
  ModalUsp,
  isConfirm,
  action,
  inputValue,
  onInputChange,
  invalidEmail,
}: HexpertModalBlockProps) => {
  return (
    <Modal
      marginTop={"80vh"}
      alignItems={"center"}
      children={
        <>
          {(ModalHeading || isConfirm) && (
            <>
              <h1 className={"c-hex-modal-block-title"}>
                {isConfirm ? ModalConfirmationHeading : ModalHeading}
              </h1>
            </>
          )}
          {!isConfirm && (
            <p className={"c-hex-modal-block-subText"}>{ModalDescription}</p>
          )}
          {isConfirm && ModalConfirmationDescription && (
            <div
              className={"c-hex-modal-block-subText"}
              dangerouslySetInnerHTML={{ __html: ModalConfirmationDescription }}
            />
          )}
          {!isConfirm && (ModalImage?.Url || ModalUsp) && (
            <>
              <div className="c-hex-modal-block-usp-section">
                {ModalImage?.Url && (
                  <div className="c-hex-modal-block-image-container">
                    <img
                      className="c-hex-modal-block-image"
                      src={imageUrlHelper(ModalImage.Url)}
                      alt={ModalHeading}
                    />
                  </div>
                )}
                {ModalUsp && ModalUsp?.length > 0 && (
                  <div
                    className="c-hex-modal-block-usp-list"
                    dangerouslySetInnerHTML={{ __html: ModalUsp }}
                  ></div>
                )}
              </div>
            </>
          )}
          {!isConfirm && (
            <>
              <div className={"c-hex-modal-block-email-wrapper"}>
                {ModalTextboxPlaceholder && onInputChange && (
                  <Input
                    placeHolder={ModalTextboxPlaceholder}
                    value={inputValue}
                    onChange={onInputChange}
                  />
                )}
                {ModalButtonText && action && (
                  <Button action={action} label={ModalButtonText} />
                )}
              </div>
            </>
          )}
        </>
      }
    />
  );
};
